import { render, staticRenderFns } from "./VoiceCallLogView.vue?vue&type=template&id=0e62ab4f&scoped=true&"
import script from "./VoiceCallLogView.vue?vue&type=script&lang=js&"
export * from "./VoiceCallLogView.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCallLogView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VoiceCallLogView.vue?vue&type=style&index=1&id=0e62ab4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e62ab4f",
  null
  
)

export default component.exports